export const SCROLL_TO_TOP: ScrollIntoViewOptions = {
  behavior: 'instant',
  block: 'start',
};

export const SCROLL_TO_START: ScrollIntoViewOptions = { block: 'start' };

export const scrollToElement = (
  target: string | Element | null | undefined,
  options: ScrollIntoViewOptions = {},
) => {
  const element =
    typeof target === 'string' ? document.getElementById(target) : target;
  element?.scrollIntoView({ behavior: 'smooth', ...options });
};

export const scrollToTop = (container: HTMLElement | null) => {
  container?.scrollTo({ top: 0, behavior: 'instant' });
  scrollToElement(container, SCROLL_TO_TOP);
};
